import { Component } from '@angular/core';

@Component({
  selector: 'app-sat-config-page',
  templateUrl: './sat-config-page.component.html',
  styleUrls: ['./sat-config-page.component.scss'],

  standalone: false,
})
export class SatConfigPageComponent {}
